import React, { createContext, useContext, useEffect, useState } from "react";
import { adminMe, adminLogin, clearToken, setToken, getToken, publicApi } from "../lib/api";

const AuthCtx = createContext({ user: null, loading: true, login: async () => {}, loginPin: async () => {}, logout: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = getToken();
    if (!t) {
      setLoading(false);
      return;
    }
    adminMe()
      .then((u) => setUser(u))
      .catch(() => clearToken())
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const data = await adminLogin(email, password);
    setToken(data.token);
    setUser(data.user);
    return data;
  };

  const loginPin = async (pin) => {
    const { data } = await publicApi.post("/admin/login-pin", { pin });
    setToken(data.token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    clearToken();
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, loginPin, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
